/**
 * Owner: Masa Bayu
 * File: library-surface-state.ts
 * Date:Time: 2026-09-16 06:40
 * Description: T4-E2 library UI surface states — empty/loading/error/recovery.
 */
import { assertT4E1SecurityIntact } from './library-security';
export const QXREAD_LIBRARY_SURFACE_STATES = [
    'loading',
    'ready',
    'empty',
    'error',
    'recovery',
];
export function resolveLibrarySurfaceView(input) {
    assertT4E1SecurityIntact();
    if (input.loading === true) {
        return Object.freeze({
            state: 'loading',
            message: 'Loading library projection',
            itemCount: 0,
            canRetry: false,
        });
    }
    if (input.errorMessage !== undefined &&
        input.errorMessage !== null &&
        input.errorMessage.length > 0) {
        return Object.freeze({
            state: 'error',
            message: input.errorMessage,
            itemCount: input.items.length,
            canRetry: true,
        });
    }
    if (input.recoveryRequired === true) {
        return Object.freeze({
            state: 'recovery',
            message: 'Library sync recovery required — entitlement remains authoritative',
            itemCount: input.items.length,
            canRetry: true,
        });
    }
    const visible = input.items.filter((item) => item.state !== 'removed' && item.state !== 'archived');
    if (visible.length === 0) {
        return Object.freeze({
            state: 'empty',
            message: 'No library titles yet — entitlement grants appear here after purchase',
            itemCount: 0,
            canRetry: false,
        });
    }
    return Object.freeze({
        state: 'ready',
        message: 'Library projection ready',
        itemCount: visible.length,
        canRetry: false,
    });
}
/** UI shelf state never grants entitlement or Reader access. */
export function librarySurfaceCannotGrantAccess(_view) {
    return true;
}
//# sourceMappingURL=library-surface-state.js.map